import { FC } from 'react';

import { ProgressLineProps } from './types';

import styles from './styles.module.scss';

export const ProgressLine: FC<ProgressLineProps> = ({ progressValue, status }) => {
  const color = status === 'No' ? '#EBEEF2' : '#52B36B';

  return (
    <div className={styles.progressBar}>
      {progressValue > 0 && (
        <div className={styles.progressBar__line} style={{ width: `${progressValue}%`, background: color }} />
      )}
    </div>
  );
};
